import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../lib/auth'

const navItems = [
  { path: '/', label: 'الرئيسية', icon: '📊' },
  { path: '/playlists', label: 'قوائم التشغيل', icon: '📺' },
  { path: '/queue', label: 'الطابور', icon: '⚙️' },
  { path: '/settings', label: 'الإعدادات', icon: '🔧' },
]

export default function Layout({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const { user, logout } = useAuth()

  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <aside className="w-56 bg-vertex-navy border-l border-vertex-surface flex flex-col">
        <div className="p-4 border-b border-vertex-surface">
          <h1 className="text-vertex-gold font-bold text-lg">Vertex</h1>
          <p className="text-vertex-gold-light text-xs">Content Factory</p>
        </div>
        <nav className="flex-1 py-4">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                (item.path === '/' ? location.pathname === '/' : location.pathname.startsWith(item.path))
                  ? 'bg-vertex-surface text-vertex-gold border-r-2 border-vertex-gold'
                  : 'text-gray-400 hover:text-white hover:bg-vertex-surface/50'
              }`}
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>

        {/* User & Logout */}
        <div className="p-4 border-t border-vertex-surface">
          {user && (
            <div className="flex items-center justify-between mb-2">
              <div>
                <div className="text-xs text-white font-bold">{user.display_name || user.username}</div>
                <div className="text-[10px] text-gray-500" dir="ltr">@{user.username}</div>
              </div>
              <span className={`text-[10px] px-1.5 py-0.5 rounded ${user.role === 'superadmin' ? 'bg-vertex-gold/20 text-vertex-gold' : 'bg-vertex-surface text-gray-400'}`}>
                {user.role === 'superadmin' ? 'SA' : 'Admin'}
              </span>
            </div>
          )}
          <button
            onClick={logout}
            className="w-full text-xs text-gray-500 hover:text-red-400 hover:bg-red-900/10 px-2 py-1.5 rounded transition-colors text-right"
          >
            تسجيل الخروج
          </button>
          <div className="text-[10px] text-gray-600 mt-2">Vertex Business School</div>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 p-6 overflow-auto">
        {children}
      </main>
    </div>
  )
}
